import { type Room, type Tenant, type RoomMember, type ResidencyRegistration, type BoardingHouseInfo, RoomStatus, ResidencyStatus } from './types';

export const ELECTRICITY_PRICE = 4000;

// This data is now primarily for migration purposes from older app versions.
// New rooms will be generated dynamically based on settings.
export const ROOMS_DATA: Room[] = [
  { id: 'R01', roomNumber: '01', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R02', roomNumber: '02', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R03', roomNumber: '03', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R04', roomNumber: '04', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R05', roomNumber: '05', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R06', roomNumber: '06', price: 0, status: RoomStatus.Maintenance, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R07', roomNumber: '07', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi', 'Balcony'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R08', roomNumber: '08', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R09', roomNumber: '09', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R10', roomNumber: '10', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R11', roomNumber: '11', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi', 'Balcony'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R12', roomNumber: '12', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R13', roomNumber: '13', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R14', roomNumber: '14', price: 0, status: RoomStatus.Maintenance, amenities: ['A/C', 'Wi-Fi'], lastElectricityReading: 0, currentElectricityReading: 0 },
  { id: 'R15', roomNumber: '15', price: 0, status: RoomStatus.Available, amenities: ['A/C', 'Wi-Fi', 'Balcony'], lastElectricityReading: 0, currentElectricityReading: 0 },
];

export const TENANTS_DATA: Tenant[] = [];
export const MEMBERS_DATA: RoomMember[] = [];
export const RESIDENCY_DATA: ResidencyRegistration[] = [];

export const REVENUE_DATA = [
    { name: 'Jan', revenue: 4500 },
    { name: 'Feb', revenue: 4800 },
    { name: 'Mar', revenue: 5200 },
    { name: 'Apr', revenue: 5100 },
    { name: 'May', revenue: 5500 },
    { name: 'Jun', revenue: 5800 },
    { name: 'Jul', revenue: 6200 },
    { name: 'Aug', revenue: 6100 },
];

export const DEFAULT_BOARDING_HOUSE_INFO: BoardingHouseInfo = {
  name: "Nhà tró IVS",
  address: "",
  ward: "",
  city: "",
  phone: "",
  landlordName: "",
  landlordDob: "",
  landlordIdNumber: "",
  localPoliceDepartment: "",
  defaultRoomPrice: 0,
  numberOfRooms: 15,
  // Contract-specific fields
  hostName: "",
  hostBirthDate: "",
  hostIdNumber: "",
  hostIdIssueDate: "",
  hostIdIssuePlace: "",
  hostPermanentAddress: "",
};